<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-danger opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 d-block d-md-none">
            <router-link
              :to="'/'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para o início"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você confere os treinamentos pré-gravados. Os usuários também
              possuem os treinamentos disponíveis na página de suporte.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col-lg-6 d-flex align-items-stretch">
          <card shadow bodyClasses="pb-1" class="flex-grow-1">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Treinamento</h3>
                </div>
              </div>
            </div>
            <template>
              <div class="row">
                <div class="col-12 text-center">
                  <p>
                    <span
                      class="cursor-pointer link"
                      @click="
                        openLink(
                          'https://drive.google.com/file/d/1pwjHYi4D0h7hTgTw3Kp0y_AjQogl0PEc/view?usp=sharing'
                        )
                      "
                      title="Abrir link"
                      >Visão geral <i class="fas fa-video ml-1"></i>
                    </span>
                  </p>
                  <p>
                    <span
                      class="cursor-pointer link"
                      @click="
                        openLink(
                          'https://drive.google.com/drive/folders/11s7U31uAylMgCDU770Tgxwx0m183gbo6?usp=sharing'
                        )
                      "
                      title="Abrir link"
                      >Perfil <b>Empresa</b> <i class="fas fa-video ml-1"></i>
                    </span>
                  </p>
                  <p>
                    <span
                      class="cursor-pointer link"
                      @click="
                        openLink(
                          'https://drive.google.com/drive/folders/1JRaP7JwniTP3VK0A5Lz4RTkB9KqArP9L?usp=sharing'
                        )
                      "
                      title="Abrir link"
                      >Perfil <b>Colaborador</b>
                      <i class="fas fa-video ml-1"></i>
                    </span>
                  </p>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "suporte_admin",
  methods: {
    openLink(link) {
      window.open(link, "file-window", "resizable=1,height=750,width=750");
    }
  }
};
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.link {
  color: #5e72e4;
}
.link:hover {
  color: #233dd2;
}
</style>
